import React from 'react';

export function Logo() {
  return (<img src="https://birds-quiz.netlify.app/static/media/logo.4f82cd73.svg" alt="Bird"></img>)
}